// src/hooks/useAuth.jsx
import { useState, useEffect } from "react";

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      const token =
        localStorage.getItem("access_token") ||
        sessionStorage.getItem("access_token");
      const userType =
        localStorage.getItem("role") || sessionStorage.getItem("role");

      if (token) {
        setUser({
          token,
          role: userType,
          isAuthenticated: true,
        });
      } else {
        setUser(null);
      }

      setLoading(false);
    };

    checkAuth();

    // Listen for storage changes (e.g., logout from another tab)
    window.addEventListener("storage", checkAuth);

    return () => {
      window.removeEventListener("storage", checkAuth);
    };
  }, []);

  const login = (token, role) => {
    localStorage.setItem("access_token", token);
    localStorage.setItem("role", role);
    setUser({
      token,
      role,
      isAuthenticated: true,
    });
  };

  const logout = () => {
    // Clear all possible user-related data
    const allKeys = [
      "access_token",
      "refresh_token",
      "token_type",
      "role",
      "username",
      "email",
      "user_id",
      "userId",
      "name",
      "surname",
      "student_id",
      "teacher_id",
      "currentSessionId",
      "activeConversation",
      "lastAgentSession",
      "agentContext",
      "theme",
      "language",
      "notifications",
      "lastUserId",
      "conversationHistory",
      "tempFormData",
      "redirectAfterLogin",
      "remember_me",
    ];

    allKeys.forEach((key) => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });

    // Nuclear option - clear everything
    localStorage.clear();
    sessionStorage.clear();

    setUser(null);
  };

  return {
    user,
    loading,
    login,
    logout,
    isAuthenticated: !!user,
  };
};
